import { SystemStyleObject, chakra } from '@chakra-ui/react'
import { ButtonProps, Button as VerbitButton } from '@verbit-ai/verbit-ui-library'

import { Palette } from 'src/themes/types'

const getBaseKeys = (
    variant: ButtonProps['variant'],
): Record<keyof Pick<SystemStyleObject, 'backgroundColor' | 'borderColor' | 'color'>, keyof Palette['verbitButton']> => {
    if (variant === 'primary') {
        return {
            backgroundColor: 'primaryBackgroundColor',
            borderColor: 'primaryBorderColor',
            color: 'primaryTextColor',
        }
    }

    return {
        backgroundColor: 'secondaryBackgroundColor',
        borderColor: 'secondaryBorderColor',
        color: 'secondaryTextColor',
    }
}
const getHoverKeys = (
    variant: ButtonProps['variant'],
): Record<keyof Pick<SystemStyleObject, 'backgroundColor' | 'borderColor'>, keyof Palette['verbitButton']> => {
    if (variant === 'primary') {
        return {
            backgroundColor: 'primaryHoverBgColor',
            borderColor: 'primaryHoverBorderColor',
        }
    }

    return {
        backgroundColor: 'secondaryHoverBgColor',
        borderColor: 'secondaryHoverBorderColor',
    }
}

export const Button = chakra<typeof VerbitButton, ButtonProps>(VerbitButton, {
    baseStyle: ({
        variant,
        theme: {
            palette: { verbitButton },
        },
    }) => {
        const base = getBaseKeys(variant)
        const hover = getHoverKeys(variant)

        return {
            backgroundColor: verbitButton[base.backgroundColor],
            borderColor: verbitButton[base.borderColor],
            color: verbitButton[base.color],
            _hover: {
                backgroundColor: verbitButton[hover.backgroundColor],
                borderColor: verbitButton[hover.borderColor],
            },
        }
    },
})
